<template>
    <mdb-modal :show="showModal" @close="closeModal" avatar size="lg" v-if="member">
        <mdb-modal-header :close="false">
            <img :src="member.avatar" alt="avatar" class="rounded-circle img-responsive">
        </mdb-modal-header>
        <mdb-modal-body class="mb-1">
            <mdb-card>
                <mdb-card-header class="primary-color text-white text-center">
                    <h5 class="mt-1 mb-2">{{member.name}}</h5>
                    <h6 v-if="member.title"><i>{{member.title}}</i></h6>
                </mdb-card-header>
                <mdb-card-body>
                    <div class="text-left">
                        <div>
                            <span class="member-label">Role:</span>{{member.role}}
                        </div>
                        <div>
                            <span class="member-label">Joined:</span>{{member.joined}}
                        </div>
                        <div>
                            <span class="member-label">Last Visited:</span>{{member.lastVisited}}
                        </div>
                        <div v-if="member.showReputation">
                            <span class="member-label">{{member.reputationLabel ? member.reputationLabel : "Reputation"}}:</span>{{member.reputationDisplay}}
                        </div>
                        <div v-if="member.intro">
                            <mdb-icon class="pr-2" icon="quote-left"></mdb-icon>
                            <user-content :content="member.intro" id="gp-user-intro"/>
                        </div>
                    </div>
                </mdb-card-body>
                <mdb-card-footer class="text-center">
                    <mdb-btn @click="$router.push('/conversations/?start=' + member.userId)" icon="envelope" rounded
                             size="sm">
                        Private Message
                    </mdb-btn>
                    <mdb-btn @click="navFull" icon="user" rounded size="sm">Full Profile</mdb-btn>
                    <mdb-btn @click="closeModal" icon="times-circle" rounded size="sm">Close</mdb-btn>
                </mdb-card-footer>
            </mdb-card>
        </mdb-modal-body>
    </mdb-modal>


</template>

<script>
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbIcon,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle
} from 'mdbvue';
import api from '../../services/groupsPlaceApi.js'
import UserContent from '../common/UserContent'
import {mapState} from "vuex";

export default {
        name: 'member-modal',
        data() {
            return {
                showModal: false,
                member: null
            }
        },
        computed: mapState({group: state => state.currentGroup}),
        components: {
            UserContent,
            mdbBtn,
            mdbModal,
            mdbModalHeader,
            mdbModalBody,
            mdbModalTitle,
            mdbIcon,
            mdbCard,
            mdbCardBody,
            mdbCardFooter,
            mdbCardHeader
        },
        props: {
            id: {
                type: Number,
                default: null
            }
        },
        watch: {
            id: function (n, o) {
                if (!n) return
                this.$store.dispatch("setExecuting", true)
                api.get("/member/summary/" + n).then(
                (results) => {
                    this.member = results.data
                    this.showModal = true
                },
                (error) => {
                  if (error.response.status == 403) console.log("Not authorized to view that user.")
                  else console.error("Error fetching user.", error.response)
                }).then(() =>
                        this.$store.dispatch("setExecuting", false)
                )
            }
        },
        methods: {
            closeModal: function () {
                this.showModal = false
                this.$emit("modalClosed")
            },
            navFull: function () {
                this.$router.push("/group/" + this.group.vanityPath + "/members/" + this.member.id)
            }
        }
    };
</script>
<style scoped>
    .member-label {
        font-weight: bold;
        padding-right: 5px;
    }
</style>
